import React, { useState, useEffect } from 'react';
import ChatInterface from './ChatInterface';
import YogaLogo from './YogaLogo';
import './ChatWidget.css';

const ChatWidget = ({
  position = 'bottom-right',
  theme = 'light',
  primaryColor,
  unreadCount = 0
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  // Initialize or retrieve session ID with enhanced context storage
  useEffect(() => {
    // Try to get existing session from localStorage
    let storedSessionId = localStorage.getItem('yoga-chat-session-id');

    // Check if session is still valid (not older than 30 minutes)
    const sessionTimestamp = localStorage.getItem('yoga-chat-session-timestamp');
    const now = Date.now();
    const sessionAge = sessionTimestamp ? now - parseInt(sessionTimestamp) : Infinity;
    const maxSessionAge = 30 * 60 * 1000; // 30 minutes

    if (!storedSessionId || sessionAge > maxSessionAge) {
      // Create new session ID
      storedSessionId = null; // Let the backend create a new session
      localStorage.removeItem('yoga-chat-session-id');
      localStorage.removeItem('yoga-chat-session-timestamp');
      localStorage.removeItem('yoga-chat-user-preferences');
      localStorage.removeItem('yoga-chat-conversation-context');
    } else {
      // Restore user preferences and context if available
      const storedPreferences = localStorage.getItem('yoga-chat-user-preferences');
      const storedContext = localStorage.getItem('yoga-chat-conversation-context');

      if (storedPreferences || storedContext) {
        console.log('Restored user preferences and context from localStorage');
      }
    }

    setSessionId(storedSessionId);
  }, []);

  // Save session ID and context when it's created
  const handleSessionCreated = (newSessionId) => {
    setSessionId(newSessionId);
    localStorage.setItem('yoga-chat-session-id', newSessionId);
    localStorage.setItem('yoga-chat-session-timestamp', Date.now().toString());
  };

  const handleToggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`chat-widget ${position} ${theme}`}>
      {/* Chat Button */}
      <button
        className="chat-button"
        onClick={handleToggleChat}
        aria-label="Open chat"
        style={primaryColor ? { backgroundColor: primaryColor } : {}}
      >
        <YogaLogo size={28} className="chat-icon" />

        {unreadCount > 0 && (
          <div className="unread-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </div>
        )}

        <div className="pulse-ring"></div>
      </button>

      {/* Chat Interface */}
      <ChatInterface
        isOpen={isOpen}
        onClose={handleToggleChat}
        sessionId={sessionId}
        onSessionCreated={handleSessionCreated}
      />
    </div>
  );
};

export default ChatWidget;